import { UserProfession } from '../../../../enums/UserProfession';
import BadgeIcon from '../../../../images/attendance/BadgeIcon';
import defaultProfile from '../../../../images/HY_tooth.png';
import { SolidHeartIcon, SolidStarIcon } from '@tempmee/react-icons';

import { colors } from '@tempmee/tailwind';
import { Colors } from '../../../../themes/colors';
import { getPrioritizedBadges, reorderBadges } from '../../../candidates/utils';
import { BestPickLabel } from './BestPickLabel';

export const CandidateCard = ({
  item,
  onClick,
  isSelected = false,
  isBestPick,
  containerStyle,
}) => {
  const isBadgesV2 = !!item?.candidate?.badges?.length;
  const showBadges = isBadgesV2 || item?.candidate?.currentRank?.rank;

  let displayedBadges = [];
  if (isBadgesV2) {
    displayedBadges = reorderBadges(
      getPrioritizedBadges({
        badges: item?.candidate?.badges?.sort((a, b) => a.type.localeCompare(b.type)),
      }),
      { inverted: false },
    );
  }

  return (
    <div
      style={{
        backgroundColor: isSelected ? colors.shades[0] : Colors.neutral_50,
        boxShadow: '0px 0px 10px 1px rgba(0, 0, 0, 0.15)',
        width: 208,
        height: 184,
        cursor: 'pointer',
        ...containerStyle,
      }}
      onClick={onClick}
    >
      <div
        style={{
          position: 'relative',
          height: 4,
          backgroundColor: isSelected ? colors.secondary[500] : 'transparent',
          width: 'calc(100% + 2px)',
          marginLeft: -1,
        }}
      >
        {/* {isBestPick && <BestPickLabel />} */}
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 12,
          paddingTop: 12,
        }}
      >
        <div
          style={{
            position: 'relative',
            border: `3px solid ${item?.isFavorite ? colors.favorites[400] : 'transparent'}`,
            width: 62,
            height: 62,
            borderRadius: 62,
            alignItems: 'center',
            justifyContent: 'center',
            padding: 2,
          }}
        >
          {item?.candidate && item?.candidate.profile_image ? (
            <img
              src={item?.candidate.profile_image}
              style={{
                width: 62,
                height: 62,
                borderRadius: 31,
                objectFit: 'cover',
              }}
              alt="profile_image"
            />
          ) : (
            <div className="default_circle_container">
              <img src={defaultProfile} alt="profile_image" width="62px" />
            </div>
          )}
          {item?.isFavorite && (
            <div style={{ position: 'absolute', top: '66%', right: -2 }}>
              <SolidHeartIcon color={colors.favorites[400]} width={18} />
            </div>
          )}
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <SolidStarIcon size={20} color={colors.success[500]} />
          <b
            style={{
              fontSize: 16,
              marginRight: 5,
              color: colors.neutral[600],
              fontFamily: 'Nunito',
            }}
          >
            {item?.candidate?.average_rating?.toFixed(1) || '5.0'}
          </b>
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          paddingTop: 4,
        }}
      >
        <b
          style={{
            fontSize: 18,
            color: colors.neutral[600],
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: 180,
          }}
        >
          {`${item?.candidate?.first_name} ${item?.candidate?.last_name}`}
        </b>
        <span
          style={{
            fontSize: 16,
            color: colors.neutral[500],
            marginBottom: 4,
          }}
        >
          {UserProfession.getName(item?.candidate?.license?.profession)}
        </span>
      </div>

      {showBadges ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 4,
            marginTop: 2,
          }}
        >
          {isBadgesV2 ? (
            displayedBadges?.map((badge) => (
              <img
                key={badge.type}
                className="badge"
                src={badge.imageUrl}
                alt={badge.label}
                style={{ width: 26, height: 26 }}
              />
            ))
          ) : (
            <BadgeIcon rank={item?.candidate?.currentRank?.rank} />
          )}
        </div>
      ) : null}
    </div>
  );
};
